import { FilledGreenCheck } from "components/icons/FilledGreenCheck";
import { SmallCircleCross } from "components/icons/SmallCircleCross";
import { REVIEW_STATUS } from "v2/constants/extractionReview";
import type { ReviewFieldStatus } from "v2/types/extractionReview.types";

type StatusBadgeProps = {
  status: ReviewFieldStatus;
};

type BadgeConfig = {
  label: string;
  colorClass: string;
  icon: React.ReactNode;
};

const BADGES: Partial<Record<ReviewFieldStatus, BadgeConfig>> = {
  [REVIEW_STATUS.CONFIRMED]: {
    label: "Confirmed",
    colorClass: "t-text-dark_green",
    icon: <FilledGreenCheck />,
  },
  [REVIEW_STATUS.SAVED]: {
    label: "Saved",
    colorClass: "t-text-dark_green",
    icon: <FilledGreenCheck />,
  },
  [REVIEW_STATUS.REJECTED]: {
    label: "Rejected",
    colorClass: "t-text-red",
    icon: <SmallCircleCross />,
  },
};

// Status icons ship at different intrinsic sizes and take no props — pin both to the
// 12px the design uses so the badges are visually identical. Only the icon carries the
// status colour; the label stays Black 60.
export const StatusBadge = ({ status }: StatusBadgeProps) => {
  const badge = BADGES[status];
  if (!badge) return null;
  return (
    <span className="t-flex t-items-center t-gap-0.5 t-text-body-sm t-text-text-60">
      <span
        className={`t-flex t-shrink-0 [&>svg]:t-h-3 [&>svg]:t-w-3 ${badge.colorClass}`}
      >
        {badge.icon}
      </span>
      {badge.label}
    </span>
  );
};
